/* eslint no-console:off */
/* eslint no-class-assign:off */
import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import * as actions from '../actions';
import { getHappening, getIsHappeningFetching } from '../reducers';
import Loading from '../components/Loading';
import Essay from '../components/happenings/Essay';
import Announcement from '../components/happenings/Announcement';
import Opencall from '../components/happenings/Opencall';
import Event from '../components/happenings/Event';
import Generic from '../components/happenings/Generic';

class Happening extends Component {
  componentDidMount() {
    const { happening } = this.props;
    if (typeof happening === 'undefined') {
      return;
    }
    if (happening.type === 'announcement') {
      document.querySelector('.main-wrapper').classList.add('on-full');
    } else {
      document.querySelector('.main-wrapper').classList.remove('on-full');
    }
  }
  componentDidUpdate() { //eslint-disable-line
    if (typeof happening === 'undefined') {
      return;
    }
    if (this.props.happening.type === 'announcement') {
      document.querySelector('.main-wrapper').classList.add('on-full');
    } else {
      document.querySelector('.main-wrapper').classList.remove('on-full');
    }
  }
  componentWillUnmount() { // eslint-disable-line
    document.querySelector('.main-wrapper').classList.remove('on-full');
  }
  render() {
    const { isFetching, happening, edition, lang } = this.props;
    if ((isFetching && !happening.length) || typeof happening === 'undefined') {
      return (
        <div className={`${this.front ? 'is-front' : 'inner'} ${this.foldClass} main-wrapper`}>
          <Loading />
        </div>
      );
    }
    switch (happening.type) {
      case 'opencall':
        return <Opencall {...happening} edition={edition} />;
      case 'announcement':
        return <Announcement {...happening} edition={edition} />;
      case 'essay':
        return <Essay {...happening} edition={edition} />;
      case 'event':
        return <Event {...happening} edition={edition} lang={lang} />;
      default: // generic
        return <Generic {...happening} edition={edition} />;
    }
  }
}

Happening.propTypes = {
  lang: PropTypes.string.isRequired,
  edition: PropTypes.shape({
    background: PropTypes.string,
    backgroundTextColor: PropTypes.string,
    id: PropTypes.string,
    year: PropTypes.string,
  }).isRequired,
  isFetching: PropTypes.bool.isRequired,
  happening: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    slug: PropTypes.string,
    type: PropTypes.string,
  }),
};

Happening.defaultProps = {
  happening: undefined,
};

const mapStateToProps = (state, { edition, params }) => {
  const contentId = params.id;
  return {
    happening: getHappening(state, contentId),
    isFetching: getIsHappeningFetching(state),
    edition,
    contentId,
  };
};

Happening = connect(
  mapStateToProps,
  actions,
)(Happening);

export default Happening;



// WEBPACK FOOTER //
// ./js/containers/Happening.js